import type { TaskViewDefinition, TaskViewFilters } from "@verbleif/lib/src/composables/Api/Type/TaskView/taskView.interface";
import { TASK_VIEW_CURRENT_USER } from "@verbleif/lib/src/composables/Api/Type/TaskView/taskView.interface";
import { BUILTIN_TASK_VIEW_KEYS } from "@web/features/Tasks/TaskViewKeys";

export function defaultTaskViewFilters(partial: Partial<TaskViewFilters> = {}): TaskViewFilters {
  return {
    statuses: [],
    priorities: [],
    inside: [],
    blocking: [],
    users: [],
    usersNone: false,
    userGroups: [],
    userGroupsNone: false,
    properties: [],
    propertiesNone: false,
    propertyGroups: [],
    propertyGroupsNone: false,
    sorts: [],
    createdBy: [],
    propertyStatePreset: null,
    propertyStateDate: null,
    deadline: null,
    createdAt: null,
    updatedAt: null,
    pinned: "any",
    ...partial,
  };
}

export function defaultTaskViewDefinition(partial: Omit<Partial<TaskViewDefinition>, "filters"> & { filters?: Partial<TaskViewFilters> } = {}): TaskViewDefinition {
  const { filters, ...rest } = partial;
  return {
    filters: defaultTaskViewFilters(filters),
    taskType: null,
    orderBy: "default",
    requiredScope: null,
    ...rest,
  };
}

export const BUILTIN_TASK_VIEW_DEFINITIONS: Record<string, TaskViewDefinition> = {
  [BUILTIN_TASK_VIEW_KEYS.ALL]: defaultTaskViewDefinition(),
  [BUILTIN_TASK_VIEW_KEYS.PINNED]: defaultTaskViewDefinition({
    filters: { pinned: "only" },
  }),
  [BUILTIN_TASK_VIEW_KEYS.TODAY]: defaultTaskViewDefinition({
    filters: { users: [TASK_VIEW_CURRENT_USER], deadline: "today" },
  }),
  [BUILTIN_TASK_VIEW_KEYS.MY_UNTIL_TODAY]: defaultTaskViewDefinition({
    filters: { users: [TASK_VIEW_CURRENT_USER], deadline: "through_today" },
  }),
  [BUILTIN_TASK_VIEW_KEYS.ALL_TODAY]: defaultTaskViewDefinition({
    filters: { deadline: "today" },
  }),
  [BUILTIN_TASK_VIEW_KEYS.ALL_UNTIL_TODAY]: defaultTaskViewDefinition({
    filters: { deadline: "through_today" },
  }),
  [BUILTIN_TASK_VIEW_KEYS.ASSIGNED_TO_ME]: defaultTaskViewDefinition({
    filters: { users: [TASK_VIEW_CURRENT_USER] },
  }),
  [BUILTIN_TASK_VIEW_KEYS.UNASSIGNED]: defaultTaskViewDefinition({
    filters: { usersNone: true, userGroupsNone: true },
  }),
  [BUILTIN_TASK_VIEW_KEYS.ROUTE]: defaultTaskViewDefinition({
    filters: { users: [TASK_VIEW_CURRENT_USER], deadline: "through_today" },
    orderBy: "property_position",
  }),
  [BUILTIN_TASK_VIEW_KEYS.WALK_ROUTE]: defaultTaskViewDefinition({
    filters: { deadline: "through_today" },
    orderBy: "route_position",
    requiredScope: "propertyRoute",
  }),
  [BUILTIN_TASK_VIEW_KEYS.FINISHED]: defaultTaskViewDefinition({
    filters: { statuses: [4] },
  }),
  [BUILTIN_TASK_VIEW_KEYS.CHECKED]: defaultTaskViewDefinition({
    filters: { statuses: [5] },
  }),
  [BUILTIN_TASK_VIEW_KEYS.TASK_LIST]: defaultTaskViewDefinition({
    orderBy: "task_list_position",
    requiredScope: "taskList",
  }),
  [BUILTIN_TASK_VIEW_KEYS.PER_PROPERTY]: defaultTaskViewDefinition({
    requiredScope: "property",
  }),
};
